import _ from 'lodash';

function getColumnOptions(columns) {
    return _.map(columns, function (item) {
        return {
            knownValuePath: item.knownValuePath,
            knownValues: item.knownValues,
            displayId: item.displayId,
            filterWidth: item.filterWidth,
            datasetId: item.datasetId,
            select: item.select,
            label: item.header || item.name,
            suppressSorting: item.suppressSorting,
            type: item.type,
            value: item.id
        };
    });
}

export default {
    getColumnOptions: getColumnOptions,

    getFilterOptions: function (columns) {
        return {
            activeFilters: [],
            availableFilters: getColumnOptions(columns)
        };
    }
};
